/*
  TODO
  - prevent default and set continue-btn to the default of the listener
 */

export default class Switch {

  constructor(el) {

    this.el = el;
    this.href = this.el.getAttribute('href');
    this.switchOverlay = document.querySelector(this.el.getAttribute('data-content'));
    this.isCurrent = false;

    if (this.switchOverlay) {

      this.targetLinkEl = this.switchOverlay.querySelector('.tc-switch-link');
      this.el.addEventListener('click', this.onClick.bind(this), false);
    }
  }

  onClick(e) {

    e.preventDefault();

    this.isCurrent = true;
    this.targetLinkEl.href = this.href;
  }
};
